import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData,
  IHttpErrorPayload
} from '@fpx/core';
import { IHttpSuccessPayload, ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of, catchError, throwError } from 'rxjs';
import { Applicant, ApplicantMaintanence } from './applicant.model';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ApplicantService implements BaseFpxDataService<any> {
  applicantType: string;
  constructor(private _httpProvider: HttpProviderService) { }
  create(payload: Applicant): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setResource('/applicant');
      let bodyContent = { "applicant": payload };
      httpRequest.setBody(bodyContent);
      httpRequest.setServerContext(environment.customersPublisher);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }

  findByKey(key: any): FindByKeyFn<Applicant | null> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/applicant/{appRef}');
      httpRequest.addPathParameter('appRef', key.appRef);
      httpRequest.setMethod('GET');
      httpRequest.setServerContext(environment.customersPublisher);
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(map((res: IHttpSuccessPayload<any>) => (res.body?.applicant)?res.body?.applicant: null), map((res: any) => {
          return res ? { ...res,
            applicationtype: res.applicationtype || res.applicationtype?.code,
            source: res.source || res.source?.code,
            sourceofinfo: res.sourceofinfo || res.sourceofinfo?.code,
            cardType: res.cardType || res.cardType?.code,
            idType: res.idType || res.idType?.code,
            employmentType: (res.employmentType?.code)?res.employmentType.code:res.employmentType,
            subEmpType: (res.subEmpType?.subEmpTypeCode)?res.subEmpType?.subEmpTypeCode:res.subEmpType,
            empstatus: (res.empstatus?.code)?res.empstatus.code:res.empstatus,
            channel: res.channel
           } : null
        }), catchError((err: any) => {
          return of(null)
        }));

    };
  }

  modify(payload: Applicant): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/applicant/{appRef}');
      httpRequest.addPathParameter('appRef', payload.appRef);
      httpRequest.setMethod('PUT');
      let bodyContent = { "applicant": payload };
      httpRequest.setBody(bodyContent);
      httpRequest.setServerContext(environment.customersPublisher);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }


  findAll(criteriaQuery: CriteriaQuery): FindAllFn<Applicant[]> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/applicant');
      httpRequest.setMethod('GET');
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(
          map(
            (res: IHttpSuccessPayload<ApplicantMaintanence>) =>
              res.body.applicant
          )
        );
    };
  }


  lookup(key: any): LookUpFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('GET');
      httpRequest.setResource('/applicant');
      httpRequest.addQueryParameter('lookup', 1);
      const httpCriteria = new CriteriaQuery();
      httpCriteria.setPaginationCriteria('1', 10);
      httpCriteria.addFilterCritertia('text', 'String', 'startsWith', {
        searchText: key.searchText ?? '',
      });
      httpRequest.setCriteriaQuery(httpCriteria);

      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data;
        })
      );
    };
  }

  validate(payload): Observable<any> {
    const httpRequest = new HttpRequest();
    httpRequest.setResource('/applicant/dedupe');
    httpRequest.setMethod('POST');
    let bodyContent = { "applicantdedupe": payload };
      httpRequest.setBody(bodyContent);
    httpRequest.setServerContext(environment.commonPublisher);
    
    return this._httpProvider.invokeRestApi(httpRequest).pipe(
      map((res: IHttpSuccessPayload<any>) => {
          return res
      }),
      catchError((err) => { 
        return throwError(err.error)
      })
    );
  }

  validateDob(value): Observable<any> {
    const httpRequest = new HttpRequest();
    httpRequest.setResource('/obvalidation/dob/{dob}');
    httpRequest.addPathParameter('dob', value);
    httpRequest.setMethod('GET');
    httpRequest.setServerContext(environment.commonPublisher);
    
    return this._httpProvider.invokeRestApi(httpRequest).pipe(
      map(
        (res: IHttpSuccessPayload<any>) => {
          return res
        },
        catchError((err : IHttpErrorPayload) => { 
          return throwError(err)
        })
      )
    );
  }

  CardSelector(productCode): Observable<any> {

    const httpRequest = new HttpRequest();
    httpRequest.setResource('/getprodesc/{processCode}/{productCode}');
    httpRequest.addPathParameter('processCode', 'CARDORG');
    httpRequest.addPathParameter('productCode', productCode);
    httpRequest.setMethod('GET');
    httpRequest.setServerContext(environment.customersPublisher);
    
    return this._httpProvider.invokeRestApi(httpRequest).pipe(
      map(
        (res: IHttpSuccessPayload<any>) => {
          return res
        },
        catchError((err : IHttpErrorPayload) => { 
          return throwError(err)
        })
      )
    );
  }

}
